export const studioOverview = {
  popover: {
    title: 'Welcome to Designer Studio!',
    description:
      "Manage all your company's email signatures in one place. Create, clone, edit, or delete signatures easily—let's get started!"
  }
};
